<div class="gf-panel">
  <header class="gf-panel__head">
    <div>
      <h3 class="gf-panel__title">Geofence for {{ member.name }}</h3>
      <p class="gf-panel__subtitle">
        {{ member.designation || member.authorizationLevel | titlecase }}
      </p>
    </div>
  </header>

  <div class="gf-panel__body">
    <!-- 1. Which geofence ------------------------------------------------ -->
    <section class="gf-section">
      <h4 class="gf-section__title">Operating geofence</h4>
      <p class="gf-section__note">
        A member works inside exactly one geofence. To cover more ground, add another area to that
        geofence rather than looking for a second one here.
      </p>

      <label class="gf-choice" [class.gf-choice--selected]="selectedGeofenceId === null">
        <input type="radio" name="geofence" [checked]="selectedGeofenceId === null" (change)="selectGeofence(null)" />
        <span class="gf-choice__body">
          <span class="gf-choice__name">No geofence</span>
          <span class="gf-choice__meta">This member can check in and log visits from anywhere.</span>
        </span>
      </label>

      @for (geofence of geofences; track geofence.id) {
        <label class="gf-choice" [class.gf-choice--selected]="selectedGeofenceId === geofence.logicalGeofenceId">
          <input
            type="radio"
            name="geofence"
            [checked]="selectedGeofenceId === geofence.logicalGeofenceId"
            (change)="selectGeofence(geofence.logicalGeofenceId)" />
          <span class="gf-choice__body">
            <span class="gf-choice__name">{{ geofence.name }}</span>
            <span class="gf-choice__meta">
              Version {{ geofence.version }}
              @if (geofence.assignedMemberCount) {
                · {{ geofence.assignedMemberCount }} member{{ geofence.assignedMemberCount === 1 ? '' : 's' }} assigned
              }
            </span>
          </span>
        </label>
      }

      @if (!geofences.length) {
        <p class="gf-empty">No geofences exist on this account yet. Create one before assigning members.</p>
      }
    </section>

    <!-- 2. Map preview --------------------------------------------------- -->
    @if (selectedGeofence) {
      <section class="gf-section">
        <h4 class="gf-section__title">{{ selectedGeofence.name }} · version {{ selectedGeofence.version }}</h4>
        <app-geofence-map [areas]="previewAreas" [readonly]="true" [heightPx]="240"></app-geofence-map>
      </section>
    }

    <!-- 3. Enforced actions ---------------------------------------------- -->
    <section class="gf-section">
      <h4 class="gf-section__title">Actions this geofence blocks</h4>
      <p class="gf-section__note">
        Set per member, not per geofence — two people can share a geofence and still be held to
        different rules. Anything left unticked works from anywhere.
      </p>

      @for (option of actionOptions; track option.value) {
        <label class="gf-check" [class.gf-check--selected]="isActionSelected(option.value)">
          <input type="checkbox" [checked]="isActionSelected(option.value)" (change)="toggleAction(option.value)" />
          <span class="gf-check__body">
            <span class="gf-check__name">{{ option.label }}</span>
            <span class="gf-check__meta">{{ option.description }}</span>
          </span>
        </label>
      }
    </section>

    <!-- 4. Fail-closed warning ------------------------------------------- -->
    @if (isFailClosed) {
      <div class="gf-warning gf-warning--blocking">
        <i class="fa fa-exclamation-triangle"></i>
        <div>
          <strong>{{ member.name }} would be locked out.</strong>
          <p>
            With no geofence assigned, the {{ selectedActions.size }} action{{ selectedActions.size === 1 ? '' : 's' }}
            ticked above are denied outright — there is nothing to check the member's location against.
          </p>
          <button type="button" class="gf-link-btn" (click)="clearAllActions()">
            Untick all actions and leave this member unrestricted
          </button>
        </div>
      </div>
    } @else if (isRemovingExistingGeofence) {
      <div class="gf-warning">
        <i class="fa fa-info-circle"></i>
        <div>
          <strong>Removing this member's geofence.</strong>
          <p>
            Their enforced actions are cleared in the same save, so nothing is left denied. Any
            attendance or visit already open is unaffected.
          </p>
        </div>
      </div>
    }
  </div>

  <footer class="gf-panel__foot">
    <button type="button" class="gf-btn gf-btn--ghost" (click)="close()" [disabled]="saving">Cancel</button>
    <button type="button" class="gf-btn gf-btn--primary" (click)="save()" [disabled]="isSaveDisabled">
      {{ saving ? 'Saving…' : 'Save' }}
    </button>
  </footer>
</div>
